



import CarpCategoryListComponent from "@/components/admin/carpCategory/carpCategoryListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CarpCategoryListPage",
  components: {
    CarpCategoryListComponent,
  },
})
export default class CarpCategoryListPage extends Vue {}
